export class EndPointPaths {

  public static getalldashboarddata = 'getalldashboarddata';
  public static getproductsbygenderandproducttype = 'getproductsbygenderandproducttype';
  public static addtocart = 'addtocart';
  public static customerlogin = 'customerlogin';
  public static getallcartitemsbycustomerid = 'getallcartitemsbycustomerid';
  public static removecart = 'removecart';
  public static removeproductcart = 'removeproductcart';
  public static replacecartitemtowishlist = 'replacecartitemtowishlist';
  public static getproductbyproducttype = 'getproductbyproducttype';
  public static getcustomercartcount = 'getcustomercartcount';

  public static getalllanguages = 'getalllanguages';
  public static getallsliderimage = 'getallsliderimage';
  public static getallsociallinks = 'getallsociallinks';
  public static booksoffset = 'getallbooksbylanguageidoffset';
  public static magazineoffset = 'getallmagazinebylanguageidoffset';
  public static galleryoffset = 'getallgalleryimagesoffset';
  public static videooffset = 'getallvideosoffset';
  public static getalmahadbylangid = 'getalmahadbylangid';
  public static homepageresponse = 'homepageresponse';
  public static contactus = 'contactus';
  public static getdepartmentsbylanguageid = 'getdepartmentsbylanguageid';
  public static getallacademicbodiesoffset = 'getallacademicbodiesoffset';
  public static getallacademiresultoffset = 'getallacademiresultoffset';
  public static getallnewsnoticeoffset = 'getallnewsnoticeoffset';
  public static seachnewsnotice = 'seachnewsnotice';
  public static seachacademicresults = 'seachacademicresults';
  public static getprivacybylanguage = 'getprivacybylanguage';
  public static getallvisitorquotessoffset = 'getallvisitorquotessoffset';
  public static postformapplication = 'postformapplication';
}
